import { CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Tab, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { toggleFormCreateResources } from '../../../../../redux/actions/resources'
import { IRootState } from '../../../../../redux/types'
import { StyledTabs } from '../../../../shared/components/StyledTabs'
import TabPanel from '../../../../shared/components/TabPanel'
import {
  BrandAutocomplete,
  CancelButton,
  DropzoneMulti,
  InputCountry,
  LanguageMultiAutocomplete,
  LineAutocomplete,
  ResourcecategoryAutocomplete,
  ResourceTypeMultiAutocomplete,
  RoleAutocomplete,
  SaveButton,
  VisibilityAutocomplete
} from '../../../../shared/components/inputs'
import { StyledDialog } from '../../../../shared/styles/StyledDialog'
import useCreateHandleSubmit from '../hooks/useCreateHandleSubmit'
import useCreateMediaState from '../hooks/useCreateMediaState'

function CreateMediaModal() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { showCreateForm } = useSelector((state: IRootState) => state.resource)
  const { resource, handleInputChange, VISIBILITY } = useCreateMediaState()
  const { errorForm, msgForm, handleSubmit } = useCreateHandleSubmit(resource)

  return (
    <StyledDialog
      open={showCreateForm}
      onClose={() => dispatch(toggleFormCreateResources())}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="dialog-resource-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{t('admin.library.create-resource')}</Typography>
          <Button onClick={() => dispatch(toggleFormCreateResources())} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>

      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Grid container alignItems="flex-start" justifyContent="space-between" spacing={2}>
          <Grid xs={12} sm={6} md={resource.brand ? 4 : 6}>
            <FormControl fullWidth variant="filled">
              <BrandAutocomplete value={resource.brand} handleInputChange={handleInputChange} props={{ required: true }} />
            </FormControl>
          </Grid>

          {resource.brand && (
            <Grid xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="filled">
                <LineAutocomplete value={resource.line} brand={resource.brand} handleInputChange={handleInputChange} />
              </FormControl>
            </Grid>
          )}

          <Grid xs={12} sm={6} md={resource.brand ? 4 : 6}>
            <FormControl fullWidth variant="filled">
              <ResourceTypeMultiAutocomplete value={resource.resourcetypes} handleInputChange={handleInputChange} />
            </FormControl>
          </Grid>
        </Grid>

        <Grid xs={12}>
          <StyledTabs value={0} onChange={() => {}} aria-label="disabled tabs example">
            <Tab
              sx={{
                '&.Mui-selected': {
                  borderBottom: '2px solid',
                  borderColor: theme => theme.palette.secondary.main
                }
              }}
              label="General"
              id="simple-tab-0"
              aria-controls="simple-tabpanel-0"
            />
          </StyledTabs>
        </Grid>

        <TabPanel value={0} index={0}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={6} md={4}>
              <FormControl fullWidth variant="filled">
                <RoleAutocomplete value={resource.role} handleInputChange={handleInputChange} />
              </FormControl>
            </Grid>

            <Grid xs={12} sm={6} md={4}>
              <InputCountry value={resource.countries} handleInputChange={handleInputChange} />
            </Grid>

            <Grid xs={12} sm={6} md={4}>
              <LanguageMultiAutocomplete value={resource.languages} handleInputChange={handleInputChange} />
            </Grid>

            <Grid xs={12} sm={6}>
              <VisibilityAutocomplete value={resource.visibility} handleInputChange={handleInputChange} options={VISIBILITY} />
            </Grid>

            <Grid xs={12} sm={6}>
              <FormControl fullWidth variant="filled">
                <ResourcecategoryAutocomplete
                  value={resource.categories}
                  resourcetypes={resource.resourcetypes}
                  handleInputChange={handleInputChange}
                />
              </FormControl>
            </Grid>

            <Grid xs={12}>
              <DropzoneMulti value={resource.fileNames} handleInputChange={handleInputChange} />
              <FormHelperText error={errorForm.fileNames}>{msgForm.fileNames}</FormHelperText>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>

      <DialogActions>
        <CancelButton id="btn-cancel-resource" onClick={() => dispatch(toggleFormCreateResources())}>
          {t('cancel')}
        </CancelButton>
        <SaveButton id="btn-save-resource" onClick={() => handleSubmit()}>
          {t('save')}
        </SaveButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default CreateMediaModal
